var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEvent24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7004 5.815H16.1004V5H14.4004V5.815H9.60037V5H7.90039V5.815H7.30038C6.59797 5.81632 5.92469 6.09597 5.42801 6.59265C4.93132 7.08934 4.65171 7.76261 4.65039 8.46503V16.165C4.65171 16.8674 4.93132 17.5407 5.42801 18.0374C5.92469 18.534 6.59797 18.8137 7.30038 18.815H16.7004C17.4028 18.8137 18.0761 18.534 18.5728 18.0374C19.0694 17.5407 19.3491 16.8674 19.3504 16.165V8.46503C19.3491 7.76261 19.0694 7.08934 18.5728 6.59265C18.0761 6.09597 17.4028 5.81632 16.7004 5.815ZM7.30038 7.51501H7.90039V8.51501H9.60037V7.51501H14.4004V8.51501H16.1004V7.51501H16.7004C16.9519 7.51633 17.1928 7.6168 17.3707 7.79468C17.5486 7.97255 17.6491 8.21348 17.6504 8.46503V9.25H6.35037V8.46002C6.35169 8.20893 6.45239 7.96858 6.6304 7.7915C6.80842 7.61442 7.04929 7.51501 7.30038 7.51501ZM16.7004 17.115H7.30038C7.04843 17.115 6.80679 17.0149 6.62863 16.8367C6.45047 16.6586 6.35037 16.4169 6.35037 16.165V10.955H17.6754V16.165C17.6747 16.2917 17.6489 16.417 17.5994 16.5336C17.5498 16.6502 17.4776 16.7558 17.3869 16.8442C17.2961 16.9327 17.1887 17.0021 17.0708 17.0486C16.953 17.0951 16.827 17.1176 16.7004 17.115Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvent24Line);
export default __webpack_public_path__ + "static/media/icon_event_24_line.b22be312fcaa282ef99a3757a8d2d74c.svg";
export { ForwardRef as ReactComponent };